import React, { useEffect, useState } from 'react';
import UserPermissions from '../Service/UsersPermission';
import Swal from 'sweetalert2';

export default function useFetchPermissions(current_user_info) {
	const [state, setState] = useState({ result: [], loading: false });

	const toastWhenFail = resp => {
		Swal.fire({
			allowOutsideClick: false,
			title: 'Something went wrong!',
			text: resp,
			// icon: 'error',
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			customClass: 'otp_message_success'
		});
	};

	useEffect(() => {
		let isApiSubscribed = true;

		setState({ loading: true });

		UserPermissions.getAllPermissions()
			.then(res => {
				if (isApiSubscribed) {
					setState({ ...state, result: res, loading: false });
				}
			})
			.catch(error => {
				toastWhenFail(`Error: ${error.message}`);
				setState({ loading: false });
			});

		return () => (isApiSubscribed = false);
	}, []);
	
	return {
		state
	};
}
